import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M18.664 36a4 4 0 1 0 0-8 4 4 0 0 0 0 8M31.997 36a4 4 0 1 0 0-8 4 4 0 0 0 0 8M45.33 36a4 4 0 1 0 0-8 4 4 0 0 0 0 8" }));
export {
  a as default
};
